.gas-rental-cartbadge {
    position: fixed;
    bottom: 15px;
    right: 15px;
    z-index: 900;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8.5px 14px;
    border-radius: var(--gas-radius-l, 999px);
    background: var(--gas-color-primary, #004253);
    color: #fff;
    text-decoration: none;
    box-shadow: var(--gas-shadow-l, 0 8px 24px rgba(20, 50, 60, .28));
    font-weight: 600;
    font-size: 10.5px;
}
.gas-rental-cartbadge:hover { filter: brightness(1.08); }
.gas-rental-cartbadge__icon { font-size: 1.35em; line-height: 1; }
.gas-rental-cartbadge__count {
    background: #fff;
    color: var(--gas-color-primary, #004253);
    border-radius: 999px;
    min-width: 17px;
    height: 17px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 8.5px;
    padding: 0 4px;
}

/* Variante header (bloc « Panier location ») : inline, pas de fixed/ombre. */
.gas-rental-cartbadge--inline {
    position: static;
    bottom: auto;
    right: auto;
    z-index: auto;
    box-shadow: none;
    padding: 5px 10px;
    font-size: 10px;
    border-radius: var(--gas-radius-m, 999px);
}
.gas-rental-cartbadge--inline .gas-rental-cartbadge__count {
    min-width: 15px;
    height: 15px;
}

@media (max-width: 600px) {
    .gas-rental-cartbadge__label { display: none; }
}
